// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,json_types=true"
// @generated from file common/v1/types.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/types.proto.
 */
export const file_common_v1_types: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChVjb21tb24vdjEvdHlwZXMucHJvdG8SCWNvbW1vbi52MSJkCgdDcmVhdG9yEg8KB3VzZXJfaWQYASABKAkSDgoGb3JnX2lkGAIgASgJEhAKCHRpbWV6b25lGAMgASgJEg0KBWVtYWlsGAQgASgJEhcKD2JpbGxhYmxlX29yZ19pZBgFIAEoCSqkAgoIRGF0YVR5cGUSGQoVREFUQV9UWVBFX1VOU1BFQ0lGSUVEEAASFAoQREFUQV9UWVBFX1NUUklORxABEhMKD0RBVEFfVFlQRV9FTUFJTBACEhMKD0RBVEFfVFlQRV9QSE9ORRADEhEKDURBVEFfVFlQRV9VUkwQBBIVChFEQVRBX1RZUEVfQUREUkVTUxAFEhIKDkRBVEFfVFlQRV9EQVRFEAYSFAoQREFUQV9UWVBFX05VTUJFUhAHEhUKEURBVEFfVFlQRV9CT09MRUFOEAgSFAoQREFUQV9UWVBFX09CSkVDVBAJEhMKD0RBVEFfVFlQRV9BUlJBWRAKEhIKDkRBVEFfVFlQRV9OQU1FEAsSEwoPREFUQV9UWVBFX0lNQUdFEAxiBnByb3RvMw",
	);

/**
 * @generated from message common.v1.Creator
 */
export type Creator = Message<"common.v1.Creator"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email: string;

	/**
	 * The ID of the organization that is being billed for the creator's usage.
	 *
	 * @generated from field: string billable_org_id = 5;
	 */
	billableOrgId: string;
};

/**
 * @generated from message common.v1.Creator
 */
export type CreatorJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email?: string;

	/**
	 * The ID of the organization that is being billed for the creator's usage.
	 *
	 * @generated from field: string billable_org_id = 5;
	 */
	billableOrgId?: string;
};

/**
 * Describes the message common.v1.Creator.
 * Use `create(CreatorSchema)` to create a new message.
 */
export const CreatorSchema: GenMessage<Creator, { jsonType: CreatorJson }> = /*@__PURE__*/ messageDesc(file_common_v1_types, 0);

/**
 * @generated from enum common.v1.DataType
 */
export enum DataType {
	/**
	 * @generated from enum value: DATA_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DATA_TYPE_STRING = 1;
	 */
	STRING = 1,

	/**
	 * @generated from enum value: DATA_TYPE_EMAIL = 2;
	 */
	EMAIL = 2,

	/**
	 * @generated from enum value: DATA_TYPE_PHONE = 3;
	 */
	PHONE = 3,

	/**
	 * @generated from enum value: DATA_TYPE_URL = 4;
	 */
	URL = 4,

	/**
	 * @generated from enum value: DATA_TYPE_ADDRESS = 5;
	 */
	ADDRESS = 5,

	/**
	 * @generated from enum value: DATA_TYPE_DATE = 6;
	 */
	DATE = 6,

	/**
	 * @generated from enum value: DATA_TYPE_NUMBER = 7;
	 */
	NUMBER = 7,

	/**
	 * @generated from enum value: DATA_TYPE_BOOLEAN = 8;
	 */
	BOOLEAN = 8,

	/**
	 * @generated from enum value: DATA_TYPE_OBJECT = 9;
	 */
	OBJECT = 9,

	/**
	 * @generated from enum value: DATA_TYPE_ARRAY = 10;
	 */
	ARRAY = 10,

	/**
	 * @generated from enum value: DATA_TYPE_NAME = 11;
	 */
	NAME = 11,

	/**
	 * @generated from enum value: DATA_TYPE_IMAGE = 12;
	 */
	IMAGE = 12,
}

/**
 * @generated from enum common.v1.DataType
 */
export type DataTypeJson = "DATA_TYPE_UNSPECIFIED" | "DATA_TYPE_STRING" | "DATA_TYPE_EMAIL" | "DATA_TYPE_PHONE" | "DATA_TYPE_URL" | "DATA_TYPE_ADDRESS" | "DATA_TYPE_DATE" | "DATA_TYPE_NUMBER" | "DATA_TYPE_BOOLEAN" | "DATA_TYPE_OBJECT" | "DATA_TYPE_ARRAY" | "DATA_TYPE_NAME" | "DATA_TYPE_IMAGE";

/**
 * Describes the enum common.v1.DataType.
 */
export const DataTypeSchema: GenEnum<DataType, DataTypeJson> = /*@__PURE__*/ enumDesc(file_common_v1_types, 0);
